module.exports = __webpack_public_path__ + "static/media/info.95533d2b.png";